export enum ChangeTypes {
  added = 1,
  removed = 2,
  edited = 3
}
